import { ChangeEvent } from 'react';

import { Tutorial } from 'models/Tutorial';

import { TextField, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Grid from '@mui/material/Grid2';

interface Props {
  tutorial: Tutorial;
  onFormFieldUpdate: (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  onParkImageUpdate: (e: ChangeEvent<HTMLInputElement>) => void;
}
const WelcomeScreenOneForm = ({
  tutorial,
  onFormFieldUpdate,
  onParkImageUpdate,
}: Props) => (
  <form>
    <Grid
      container
      spacing={2}
      direction='column'
      justifyContent='center'
      alignItems='stretch'
    >
      <Grid size={6}>
        <Button
          variant='contained'
          color='primary'
          component='label'
          startIcon={<CloudUploadIcon />}
        >
          Select Image
          <input
            type='file'
            accept='.jpeg, .png, .jpg'
            hidden
            onChange={e => onParkImageUpdate(e)}
          />
        </Button>
      </Grid>

      <Grid size={6}>
        <TextField
          id='game-name'
          label='Explorer Quest Name'
          onChange={onFormFieldUpdate}
          name='ScavengerHuntName'
          value={tutorial.ScavengerHuntName}
          fullWidth
          variant='outlined'
        />
      </Grid>
    </Grid>
  </form>
);

export default WelcomeScreenOneForm;
